import React from "react";
import { Button } from "@material-ui/core";
import A404 from "../image/404.webp";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="A404044">
      <header>{/* <Header /> */}</header>
      <div className="A404_section">
        <img src={A404} alt="404 img" />
        <h1>Page Not Found</h1>
        <Button>
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    
      {/* <Footer /> */}
    </div>
  );
}

export default Home;
